import { createBrowserRouter, Outlet, RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { GameProvider } from './GameContext'
import CourseSelect from './pages/CourseSelect'
import CourseDetail from './pages/CourseDetail'
import ScanCourse from './pages/ScanCourse'
import SetupPlayers from './pages/SetupPlayers'
import Rules from './pages/Rules'
import Play from './pages/Play'
import Results from './pages/Results'
import Leaderboard from './pages/Leaderboard'
import Standings from './pages/Standings'

function Layout() {
  return (
    <GameProvider>
      <div className="min-h-screen px-4">
        <Outlet />
      </div>
      <Toaster
        theme="light"
        className="toaster group"
        style={{
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        }}
      />
    </GameProvider>
  )
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <CourseSelect /> },
      { path: 'scan', element: <ScanCourse /> },
      { path: 'course/:courseId', element: <CourseDetail /> },
      { path: 'setup', element: <SetupPlayers /> },
      { path: 'rules', element: <Rules /> },
      { path: 'play', element: <Play /> },
      { path: 'summary', element: <Results /> },
      { path: 'standings', element: <Standings /> },
      { path: 'leaderboard', element: <Leaderboard /> },
    ],
  },
])

export function App() {
  return <RouterProvider router={router} />
}